// Add your custom JS here.
( function( $ ) {

    AOS.init();



    // HEADER SCROLL FUNCTIONS
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('#wrapper-navbar').addClass('off-top');

        }
        if($(this).scrollTop() < 50)
        {   
            $('#wrapper-navbar').removeClass('off-top');
            $(".menu a").removeClass('active');
        }
    });

    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('#wrapper-navbar').addClass('hide');
        } else {
            $('#wrapper-navbar').removeClass('hide');
        }
        lastScrollTop = st;
    });
    



    lottie.loadAnimation({
        container: document.getElementById('lottie-animation'), // the DOM element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: '/wp-content/themes/understrap-child/lottie/valmy-logo.json' // the path to the animation json file
    });




    // VIDEO PLAYER

    if ($("#vimeoplayer").length) {

        const vimeoIframe = document.querySelector("#vimeoplayer");
        const vimeoPlayer = new Vimeo.Player(vimeoIframe);

        $(".section-three .vimeo-back-wrap").on("click", function () {
            $(".video-popup").fadeIn(150);
            vimeoPlayer.play();
        });

        $(".video-popup .close").on("click", function () {
            $(".video-popup").fadeOut(150);
            vimeoPlayer.pause();
        });
    }


    // HEADER MENU TOGGLE
    $(".menu-toggle").on("click", function () {
        $("#wrapper-navbar, .mobile-header-info").toggleClass('active');
    });




    // HEADER MENU TOGGLE
    $(".image-toggle").on("click", function () {
        var popup = $(this).attr("popup");

        $("." + popup + "").fadeIn(); 
    });

    $(".image-one-popup .close, .image-two-popup .close").on("click", function () {
        $(this).parent().fadeOut(150);
    });




    $('#wrapper-navbar .menu a').each(function(index) {
        // Set the itemindex attribute based on the index
        $(this).attr('itemindex', index + 1);
    });



    $(".page-menu li:first-child a").addClass("active");

    $(window).on("scroll", function () {
        $(".pageanchor").each(function () {
            if ($(window).scrollTop() >= $(this).offset().top - 50) {
                var currentItem = $(this).attr("anchor");
                $(".menu a").removeClass("active");
                $("a[itemindex=" + currentItem + "]").addClass("active");

                $("#wrapper-navbar").removeClass("section-1").removeClass("section-2").removeClass("section-3").removeClass("section-4");
                $("#wrapper-navbar").addClass("section-" + currentItem + "");
            }
        });
    });


    $(".menu a").on("click", function () {
        $(".menu a, #wrapper-navbar, .mobile-header-info").removeClass("active");
        $(this).addClass("active");
    });



    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });
    
    


    $(".toggles .toggle:first-child").addClass("active");
     
    $(".section-seven .toggle").on("click", function () {
        var index = $(this).index() + 1;
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $(".section-seven .tab").css("display", "none");
        $(".section-seven .tab:nth-child(" + index + ")").css("display", "flex");
    });


    $(".section-nine .toggle").on("click", function () {
        var index = $(this).index() + 1;
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $(".section-nine .tab").css("display", "none");
        $(".section-nine .tab:nth-child(" + index + ")").css("display", "flex");
    });




    // Check if the viewport width is below 992px
    if ($(window).width() < 992) {
        // Select and process the target elements
        var $keys = $('.section-four .key');
        
        // Group every 4 elements and wrap them in a "swiper-slide" div
        for (var i = 0; i < $keys.length; i += 4) {
            $keys.slice(i, i + 4).wrapAll('<div class="swiper-slide"></div>');
        }
        
        // Wrap all "swiper-slide" divs in a "swiper-wrapper" div
        $('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');

        // Wrap the "swiper-wrapper" in a div with classes "swiper" and "key-swiper"
        $('.swiper-wrapper').wrap('<div class="swiper key-swiper"></div>');
        
        // Append a pagination div
        $('.keys').append('<div class="key-pagination"></div>');
        
        // Initialize Swiper
        var swiper = new Swiper('.key-swiper', {
            slidesPerView: 'auto',
            pagination: {
                el: '.key-pagination',
                clickable: true,
            },
        });

        $("#wrapper-footer .container").clone().appendTo("#wrapper-navbar ul");
    }


})(jQuery);



